import { render, staticRenderFns } from "./PaymentReceiptSheet.vue?vue&type=template&id=6c86a70c&"
import script from "./PaymentReceiptSheet.vue?vue&type=script&lang=js&"
export * from "./PaymentReceiptSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports